export class UserAcceptanceData {
    public BCID: number = 0;
    public AllowDataUse: boolean = false;
    public AllowMarketingCommunication: boolean = false;
    constructor(userAcceptanceData: UserAcceptanceData) {
        this.BCID = userAcceptanceData.BCID || 0;
        this.AllowDataUse = userAcceptanceData.AllowDataUse || false;
        this.AllowMarketingCommunication = userAcceptanceData.AllowMarketingCommunication || false;
    }
}